import { AppProvider } from '@shopify/polaris';
import Orders from './orders';
import ShowLocation from './locations/Show';
import DiscountCodes from './discount-codes';
import Customers from './customers';
import Activity from './users/Activity';

import translations from '@shopify/polaris/locales/en.json';

import {BrowserRouter as Router, Switch, Route, Redirect, useLocation} from 'react-router-dom';
import SendQuote from "./send-quote/index";
import {ShowUser, Users} from "./users";
import BillingAddresses from './customers/BillingAddresses';
import BillingAddressesForm from './customers/BillingAddressesForm';

const Main = () => {

    return (
        <AppProvider i18n={translations}>
            <Router>
                <Switch>
                    <Route exact path="/">
                        <Redirect to="/customers" />
                    </Route>
                    <Route exact path="/home">
                        <Redirect to="/customers" />
                    </Route>
                    <Route path="/discount-codes"><DiscountCodes /></Route>
                    <Route path="/orders/:customerid"><Orders /></Route>
                    <Route path="/customers"><Customers /></Route>
                    <Route path="/locations/:locationId"><ShowLocation /></Route>
                    <Route path="/send-quote"><SendQuote /></Route>

                    <Route path="/users/:userId"><ShowUser /></Route>
                    <Route path="/users"><Users /></Route>
                    <Route path="/usersActivity"><Activity /></Route>
                    <Route path="/billingAddresses/new"><BillingAddressesForm /></Route>
                    <Route path="/billingAddresses/:id"><BillingAddressesForm /></Route>
                    <Route path="/billingAddresses"><BillingAddresses /></Route>

                </Switch>
            </Router>
        </AppProvider>
    );
}


export default Main;
